export default function FullPageLoader() {
    return (
        <>
            <section className="em_loading" id="loaderPage">
                <div className="spinner_flash"></div>
            </section>
        </>

    )
}
